import React from 'react';
import ConsultationModal from './ConsultationModal';

const HRConsultModal = ({ showModal, setShowModal }) => {
    return <ConsultationModal showModal={showModal} setShowModal={setShowModal} ctaType="hrService" />;
};

export default HRConsultModal;